import { schema } from 'normalizr';

export const activity = new schema.Entity('activities');
export const activities = [activity];
